
import { defineComponent } from "vue";
import PrintInvoice from "./controls/PrintInvoice.vue";

export default defineComponent({
  components: { PrintInvoice },
});
